import { Stack, Typography, IconButton } from "@mui/material";
import { Minus, Plus } from "lucide-react";

interface Props {
  total: number;
  onAdd: () => void;
  onRemove: () => void;
  minimum?: number;
}

const QuantitySelector = ({ total, onAdd, onRemove, minimum = 1 }: Props) => {
  const handleRemove = () => {
    if (total > minimum) {
      onRemove();
    }
  };

  return (
    <Stack direction={"row"} spacing={2} alignItems={"center"} justifyContent={"center"}>
      <IconButton onClick={handleRemove} size="large" color="secondary" sx={{ border: "1px solid ", boxSizing: "border-box" }}>
        <Minus />
      </IconButton>
      <Typography>{total}</Typography>
      <IconButton onClick={onAdd} size="large" color="secondary" sx={{ border: "1px solid", boxSizing: "border-box" }}>
        <Plus />
      </IconButton>
    </Stack>
  );
};

export default QuantitySelector;
